import React, { useState, useCallback, useEffect, useContext } from 'react';
import Switch from "react-switch";
import AddUser from './AddUser'

//httpClient
import AuthenticationClient from './../../httpClient/Authentication'; 

//Context API for User Info
import { InfoContext } from "./../../context/InfoContext";

//react-bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Spinner from 'react-bootstrap/Spinner';
// import RecordDetails from './components/RecordDetails';

const ManageUsers = () => {
    //current user Info
    const { info, setInfo } = useContext(InfoContext);    
    const [searchText, setSearchText] = useState(""); //Set Search Text
    const [currentRecord, setCurrentRecord] = useState(null); //Set Current Record variable
    const [loading, setLoading] = useState({currentUserRecordLoading: false, userListLoading: false, baseListLoading: false});
    const [reloadCurrentRecord, setReloadCurrentRecord] = useState(false);
    const [portalUsersList, setPortalUsersList] = useState([]);
    const [filteredPortalUsersList, setFilteredPortalUsersList] = useState([]);
    const [copaBasesList, setCopaBasesList] = useState([]);
    const [filteredCopaBasesList, setFilteredCopaBasesList] = useState([]);

    const updateLoading = useCallback((key,value) => {
        setLoading((loading)=>{
            return({
                ...loading,
                [key]: value
            });
        });
    },[]);

    //Fetch Portal Users 
    const loadUserRecords = useEffect(() => {
        updateLoading("userListLoading",true);

        AuthenticationClient.fetchAllUsers(info.id)
        .then(data => {
        updateLoading("userListLoading",false);
            setPortalUsersList(data.userRecords);
            setCurrentRecord(data.userRecords[0]);
        })
        .catch(err => {
            updateLoading("userListLoading",false);
        // setErrorMessage(err.response.data.Message);
        });
    
    },[]);

    useEffect(() => {
        if(currentRecord) {
            setReloadCurrentRecord(true);
        }
    },[currentRecord]);

    useEffect(() => {
        if(reloadCurrentRecord) {
            updateLoading("currentUserRecordLoading",true);

            AuthenticationClient.fetchUserRecord(currentRecord.email)
            .then(data => {
                updateLoading("currentUserRecordLoading",false);
                setCurrentRecord(data.userInfo);
                setCopaBasesList(data.copaUserBases);
                setReloadCurrentRecord(false);
            })
            .catch(err => {
                updateLoading("currentUserRecordLoading",false);
            // setErrorMessage(err.response.data.Message);
            });
        }
    },[reloadCurrentRecord]);

    const updateAccountStatus = (key,value) => {
        let payload= {
            "userID":  currentRecord.id,
            [key]:  value
        };

        updateLoading("currentUserRecordLoading",true);
        AuthenticationClient.updateAccountStatus(payload)
        .then(data => {
            updateLoading("currentUserRecordLoading",false);
            setReloadCurrentRecord(true)
        })
        .catch(err => {
            updateLoading("currentUserRecordLoading",false);
        });
    }

    const updateUserBaseList = (value) => {
        let payload= {
            "email":  currentRecord.email,
            "baseID":  value
        };

        updateLoading("baseListLoading",true);
        AuthenticationClient.updateUserBaseList(payload)
        .then(data => {
            updateLoading("baseListLoading",false);
            setReloadCurrentRecord(true)
        })
        .catch(err => {
            updateLoading("baseListLoading",false);
        });
    }

    const portalUsers = portalUsersList.map((record, key) => <ListGroup.Item key={record.id} variant={currentRecord && !currentRecord.isActive ? "" : "warning"} active={ currentRecord && record.id === currentRecord.id ? true : false } onClick={()=>setCurrentRecord(record)}>{record.fullName} ({record.email})</ListGroup.Item>);
    
    const filteredPortalUsers = filteredPortalUsersList.map((record, key) => <ListGroup.Item key={record.id} variant={currentRecord && !currentRecord.isActive ? "" : "warning"} active={ currentRecord && record.id === currentRecord.id ? true : false } onClick={()=>setCurrentRecord(record)}>{record.fullName} ({record.email})</ListGroup.Item>);

    const copaBases = copaBasesList.map((base, key) => 
            <Row key={base.id}>
                <Col md="auto">
                    <Switch onColor="#007BFF" onChange={(checked) => updateUserBaseList(base.id)} checked={base.isActive} />
                </Col>
                <Col>
                    {base.name}
                </Col>
            </Row>);

    const filteredCopaBases = filteredCopaBasesList.map((base, key) =>  
            <Row  key={base.id}>
                <Col md="auto">
                    <Switch onColor="#007BFF" onChange={(checked) => updateUserBaseList(base.id)} checked={base.isActive} />
                </Col>
                <Col>
                    {base.name}
                </Col>
            </Row>);

    return (
        <div className="innerBody">
            <Container fluid>
                <Row>
                    <Col xs={5}>
                        <AddUser />
                        <InputGroup className="mb-3">
                            <FormControl
                                placeholder="Filter by Name or Email"
                                onChange={(e)=>setFilteredPortalUsersList(portalUsersList.filter(user => (user.fullName.toLowerCase().includes(e.target.value.toLowerCase()) 
                                                                            || user.email.toLowerCase().includes(e.target.value.toLowerCase()))
                                                                       ))}
                            />
                        </InputGroup>

                        <hr />

                        {loading.userListLoading && <Spinner animation="border" variant="primary" />}

                        <ListGroup>
                            {filteredPortalUsers.length > 0 ? filteredPortalUsers : portalUsers}
                        </ListGroup>                
                    </Col>
                    <Col>
                        { currentRecord && info.isAdmin && <div>
                            <Container fluid>
                                <Row lg={1}>
                                    <Col>
                                        <h4><span className="activeLink subtitle">{currentRecord.fullName}</span> ({currentRecord.email})</h4>
                                        <hr />
                                        <Container fluid>
                                            <Row>
                                                <Col>
                                                    <span><strong>Email:</strong> <a href={`mailto:${currentRecord.email}`}>{currentRecord.email}</a></span> <br />
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Col>
                                    <Col>
                                        <br />
                                        <br />
                                        <h4 className="subtitle">Account Settings</h4>
                                        <hr />
                                        <Container>
                                            <Row>
                                                <Col md="auto">
                                                    <Switch onColor="#007BFF" onChange={(checked) => updateAccountStatus("active",checked)} checked={currentRecord.isActive} />
                                                </Col>
                                                <Col md="auto">
                                                    <strong>Account Active</strong>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md="auto">
                                                    <Switch onColor="#007BFF" onChange={(checked) => updateAccountStatus("isAdmin",checked)} checked={currentRecord.isAdmin} />
                                                </Col>
                                                <Col md="auto">
                                                <strong>Admin Account</strong>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md="auto">
                                                    <Switch onColor="#007BFF" onChange={(checked) => updateAccountStatus("writeAccess",checked)} checked={currentRecord.writeAccess} />
                                                </Col>
                                                <Col md="auto">
                                                <strong>Write Access</strong>
                                                </Col>
                                            </Row>                                               
                                        </Container>
                                    </Col>
                                    <Col>
                                        <br />
                                        <br />
                                        <h4 className="subtitle">Bases ({filteredCopaBasesList.length || copaBasesList.length})</h4>
                                        <hr />
                                        <Container>
                                            <Row>
                                                <InputGroup className="mb-3">
                                                    <FormControl
                                                        placeholder="Filter by Name" 
                                                        onChange={(e)=>setFilteredCopaBasesList(copaBasesList.filter(base => base.name.toLowerCase().includes(e.target.value.toLowerCase())))}
                                                />
                                                </InputGroup>
                                            </Row>
                                            <Row>
                                                <Container>
                                                    {(loading.baseListLoading || loading.currentUserRecordLoading) && <Spinner animation="border" variant="primary" />}
                                                    {!loading.baseListLoading && !loading.currentUserRecordLoading && <div>{filteredCopaBases.length > 0 ? filteredCopaBases : copaBases}</div> }
                                                </Container>
                                            </Row>                                               
                                        </Container>
                                    </Col>
                                </Row>
                            </Container>
                        </div> }

                    </Col>
                </Row>
            </Container>
        </div>
    );
};
export default ManageUsers;